// import React from "react";
import "./CustomHelpHub.css";
import QuestContext from "../QuestWrapper";
import HelphubSvg from "./CustomHelphubSvg";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import CustomHelpHubHome from "./CustomHelpHubHome";
import CustomHelpHubChat from "./CustomHelpHubChat";
import CustomHelpHubHelp from "./CustomHelpHubHelp";
import CustomHelpHubTasks from "./CustomHelpHubTasks";
import CustomHelpHubUpdates from "./CustomHelpHubUpdates";
import {
  BrandTheme,
  ContentDataType,
  HelpHubProps,
  MessageTypes,
  QuestCriteriaWithStatusType,
  QuestTypes,
} from "./CustomHelpHub.type";
import {
  getDefaultQuest,
  getEntityDetails,
  getMessages,
  getSuggetionWebsiteUrl,
  getUnreadConversations,
} from "./CustomHelphub.service";
import config from "../../config";
import addIcon from "../../assets/images/add.svg";
import resize from "../../assets/images/resize.png";
import resize2 from "../../assets/images/resize2.png";
import quest_white from "../../assets/images/quest_white.svg";
import { hexToRgb } from "./components/helperfunction";
import General, { extractGradientColors } from "../../general";

const CustomHelpHub = (props: HelpHubProps) => {
  let {
    userId,
    token,
    questId,
    uniqueUserId,
    uniqueEmailId,
    styleConfig,
    contentConfig,
    showFooter = true,
    helphubPosition = "USER_CHOICE",
    variation,
    entityLogo,
    defaultAutoPopupMessages,
    popupOpenDelay,
    autoPopupOpenAfter,
    footerText,
    footerLink,
    entityAuthenticationToken,
    isDynamicSuggetion = false,
    isPopMessageAudio = false,
    isActive,
    botLogo,
    isPopUp = true,
    accent,
    chatRefreshInterval = 60000,
    iconPosition = "right",
    iconPositionValues,
    isOpen,
    onClose,
  } = props;

  const { apiKey, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  const [selectedSection, setSelectedSection] = useState("Home");
  const [_, setPrevSelectedSection] = useState("");

  const [helpHub, setHelpHub] = useState(false);
  const [parentQuest, setParentQuest] = useState<QuestTypes>();
  const [chieldQuestCriteria, setChieldQuestCriteria] = useState<
    QuestCriteriaWithStatusType[][]
  >([]);

  const [claimStatusUpdates, setClaimStatusUpdates] = useState<string[]>([]);
  const [claimStatusTasks, setClaimStatusTasks] = useState<string[]>([]);
  const [showFeedback, setShowFeedback] = useState(true);
  const [showBottomNavigation, setShowBottomNavigation] = useState(true);
  const [taskStatus, setTaskStatus] = useState<number>(0);
  const [taskData, setTaskData] = useState<QuestCriteriaWithStatusType[]>([]);
  const [updateData, setUpdateData] = useState<QuestCriteriaWithStatusType[]>(
    []
  );
  const [chat, setChat] = useState<MessageTypes[]>([]);
  const [filterChat, setFilterChat] = useState<MessageTypes[]>([]);
  const [fetchData, setFetchData] = useState<boolean>(false);
  const [entityImage, setEntityImage] = useState<string>("");
  const [entityName, setEntityName] = useState<string>("");
  const [position, setPosition] = useState<string>("SIDEBAR");
  const [autoPopupMessage, setAutoPopupMessage] = useState<boolean>(false);
  const [sendAutoMessage, setSendAutoMessage] = useState<string>("");
  const helpHubRef = useRef(helpHub);
  const [styleConfigApi, setStyleConfigApi] = useState({});
  const [contentConfigApi, setContentConfigApi] = useState({
    Chat: {},
    Help: {},
    Updates: {},
    Tasks: {},
    Home: {},
  });
  const [showFooterApi, setShowFooterApi] = useState<boolean>(true);
  const [entityLogoApi, setEntityLogoApi] = useState<string>("");
  const [apiCallRunning, setApiCallRunning] = useState<boolean>(true);
  const [defaultAutoPopupMessagesApi, setDefaultAutoPopupMessagesApi] =
    useState<string[]>([]);
  const [openCloseChatPopup, setOpenCloseChatPopup] = useState<boolean>(false);
  const [popupOpenDelayApi, setpopupOpenDelayApi] = useState<number>(2);
  const [autoPopupOpenAfterApi, setAutoPopupOpenAfterApi] = useState<
    "ONE_DAY" | "EVERY_TIME" | "ONCE"
  >();
  const [BrandTheme, setBrandTheme] = useState<BrandTheme>({});
  const [QuestThemeData, setQuestThemeData] = useState({
    accentColor: accent ? accent : "",
    borderRadius: "",
    images: [],
    buttonColor: "",
  });
  const [contentData, setContentData] = useState<ContentDataType>({});
  const [sectionConfigState, setSectionConfigState] = useState({
    Home: true,
    Chat: true,
    FAQs: true,
    Updates: true,
    Tasks: true,
  });
  const [isFetchedEntityDetails, setIsFetchedEntityDetails] = useState(false);
  const hasUnreadMessages = useMemo(() => chat.some((ele) => ele.isReadByUser === false), [chat]);

  let GeneralFunctions = new General("mixpanel", apiType, apiKey, entityId);

  useEffect(() => {
    if (apiCallRunning) return;

    const interval = setInterval(async () => {
      const response = await getMessages(
        BACKEND_URL,
        entityId,
        userId,
        token,
        apiKey,
        "",
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );

      if (response && response.data) {
        const filteredMessages = filterByLastMessage(response.data);
        setChat(filteredMessages);
        setFilterChat(filteredMessages);
      } else {
        console.error("No data received or response is undefined.");
      }
    }, chatRefreshInterval);

    return () => clearInterval(interval);
  }, [apiCallRunning]);

  useEffect(() => {
    if (helpHub == true) {
      helpHubRef.current = helpHub;
    }
  }, [helpHub]);

  const getSuggestions = async () => {
    getSuggetionWebsiteUrl(
      BACKEND_URL,
      entityId,
      userId,
      token,
      apiKey,
      uniqueUserId,
      uniqueEmailId,
      apiType,
      entityAuthenticationToken
    ).then((result) => {
      if (result?.questions?.length) {
        setDefaultAutoPopupMessagesApi(
          result?.questions?.map((ele: any) => {
            return ele.text;
          }) || defaultAutoPopupMessages
        );
      } else {
        defaultAutoPopupMessages &&
          setDefaultAutoPopupMessagesApi(defaultAutoPopupMessages);
      }
    });
  };

  const tempFunc = () => {
    let lastPopupOpen: string | null = localStorage.getItem("lastPopupOpen");
    let difference =
      new Date().getTime() -
      (lastPopupOpen
        ? new Date(lastPopupOpen).getTime()
        : new Date().getTime());
    let delayCriteria = !lastPopupOpen
      ? true
      : autoPopupOpenAfterApi == "ONE_DAY"
        ? difference >= 86400000
        : autoPopupOpenAfterApi == "EVERY_TIME"
          ? true
          : !lastPopupOpen;
    if (!!defaultAutoPopupMessagesApi.length && delayCriteria) {
      const timer = setTimeout(() => {
        if (helpHubRef.current === false) {
          setAutoPopupMessage(true);
          localStorage.setItem("lastPopupOpen", new Date().toString());
        }
      }, popupOpenDelayApi * 1000);
      return () => clearTimeout(timer);
    }
  };

  useEffect(() => {
    tempFunc();
  }, [defaultAutoPopupMessagesApi, popupOpenDelayApi]);

  useEffect(() => {
    if (helpHub == true) {
      setAutoPopupMessage(false);
    }
  }, [helpHub]);

  useEffect(() => {
    if (sendAutoMessage != "") {
      setHelpHub(true);
      setSelectedSection("Chat");
    }
  }, [sendAutoMessage]);

  const setPositionInLocal = (position: string) => {
    setPosition(position);
  };

  useEffect(() => {
    if (helphubPosition != "USER_CHOICE") {
      setPosition(helphubPosition);
    }
  }, []);

  useEffect(() => {
    setTaskStatus(
      Math.ceil(
        100 * (claimStatusTasks?.length / chieldQuestCriteria[3]?.length)
      )
    );
  }, [claimStatusTasks]);

  const getOrCreateQuest = async () => {
    setApiCallRunning(true);
    let qId = questId || "q-default-helphub";
    let getResult = await getDefaultQuest(
      BACKEND_URL,
      entityId,
      qId,
      userId,
      token,
      apiKey,
      uniqueUserId,
      uniqueEmailId,
      apiType,
      variation,
      entityAuthenticationToken
    );

    setApiCallRunning(false);
    if (qId !== "q-default-helphub") {
      GeneralFunctions.trackEvent(
        "quest-helphub-loaded",
        (uniqueUserId || userId || user.userId)!,
        {},
        true,
        !uniqueUserId,
        true
      );
    }
    const helpHubThemeData = {
      styleConfig: getResult?.data?.sdkConfig?.uiProps?.styleConfig,
      contentConfig: getResult?.data?.sdkConfig?.uiProps?.contentConfig,
    };

    setShowFooterApi(
      getResult?.data?.sdkConfig?.uiProps?.showFooter
    );

    setBrandTheme(
      getResult?.data?.sdkConfig?.uiProps?.BrandTheme?.properties || {}
    );
    setQuestThemeData({
      ...getResult?.data?.sdkConfig?.uiProps?.questThemeData,
      accentColor: getResult?.data?.sdkConfig?.uiProps?.questThemeData
        .accentColor
        ? getResult?.data?.sdkConfig?.uiProps?.questThemeData.accentColor
        : accent,
    });
    setContentData(getResult?.data?.sdkConfig?.uiProps?.contentConfig || {});
    setAutoPopupOpenAfterApi(
      autoPopupOpenAfter ||
      getResult?.data?.sdkConfig?.uiProps?.autoPopupOpenAfter ||
      "ONE_DAY"
    );
    setpopupOpenDelayApi(
      popupOpenDelay || getResult?.data?.sdkConfig?.uiProps?.popupOpenDelay || 2
    );
    setDefaultAutoPopupMessagesApi(
      defaultAutoPopupMessages ||
      getResult?.data?.sdkConfig?.uiProps?.defaultAutoPopupMessages ||
      []
    );
    setEntityLogoApi(
      entityLogo || getResult?.data?.sdkConfig?.uiProps?.entityLogo
    );
    setStyleConfigApi((prev) => ({
      ...prev,
      ...getResult?.data?.sdkConfig?.uiProps?.styleConfig,
      ...styleConfig,
    }));
    localStorage.setItem(entityId, JSON.stringify(helpHubThemeData));
    setContentConfigApi((prev) => ({
      ...prev,
      ...getResult?.data?.sdkConfig?.uiProps?.contentConfig,
      ...contentConfig,
    }));
    if (getResult?.data?.metadata?.sectionConfig) {
      if (getResult?.data?.metadata?.sectionConfig.Home) {
        setSelectedSection("Home");
      } else if (getResult?.data?.metadata?.sectionConfig.Chat) {
        setSelectedSection("Chat");
      } else if (getResult?.data?.metadata?.sectionConfig.FAQs) {
        setSelectedSection("Help");
      } else if (getResult?.data?.metadata?.sectionConfig.Updates) {
        setSelectedSection("Updates");
      } else if (getResult?.data?.metadata?.sectionConfig.Tasks) {
        setSelectedSection("Tasks");
      }
      setSectionConfigState(getResult?.data?.metadata?.sectionConfig);
    }

    if (!getResult?.success) {
      setApiCallRunning(true);
    } else {
      let criterias = getResult?.data.childCampaignActions?.map(
        ({ actions }: any) =>
          actions?.map((action: any) => {
            return {
              type: action.actionType,
              question: action.title || "",
              description: action.description || "",
              options: action.options || [],
              criteriaId: action.actionId,
              required: action.isRequired,
              linkTitle: action.metadata?.linkActionName || action.title || "",
              linkUrl: action.metadata?.link || "",
              manualInput: false,
              completed: Boolean(action.isCompleted),
              answer: action.metadata?.answer || "",
              createdAt: action.createdAt || "",
              imageUrl: action.metadata?.imageUrl || "",
            };
          })
      );
      setParentQuest(getResult?.data);
      setTaskData(criterias[3]);
      setUpdateData(criterias[2]);
      setChieldQuestCriteria(criterias);
    }
  };

  const filterByLastMessage = (chatData: MessageTypes[]) => {
    let data = chatData?.sort((a, b) => {
      return (
        new Date(b?.conversations?.timestamp).getTime() -
        new Date(a?.conversations?.timestamp).getTime()
      );
    });

    return data;
  };

  const fetchChat = async () => {
    setFetchData(true);

    try {
      const response = await getMessages(
        BACKEND_URL,
        entityId,
        userId,
        token,
        apiKey,
        "",
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );

      if (response && response.data) {
        const filteredMessages = filterByLastMessage(response.data);
        setChat(filteredMessages);
        setFilterChat(filteredMessages);
      } else {
        console.error("No data received or response is undefined.");
      }
    } catch (error) {
      console.error("Error fetching chat messages:", error);
    } finally {
      setFetchData(false);
    }
  };

  const entityDetails = async () => {
    try {
      const qId = questId || "q-default-helphub";
      const response = await getEntityDetails(
        BACKEND_URL,
        entityId,
        qId,
        userId,
        token,
        apiKey,
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );

      if (response && response.data) {
        const { data } = response;
        setEntityImage(data.imageUrl);
        setEntityName(data.name);
      } else {
        console.error("No data received or response is undefined.");
      }
      setIsFetchedEntityDetails(true);
    } catch (error) {
      console.error("Error fetching entity details:", error);
    }
  };

  useEffect(() => {
    if (!apiCallRunning) {
      isDynamicSuggetion && getSuggestions();
      fetchChat();
      entityDetails();
    }
  }, [apiCallRunning]);

  useEffect(() => {
    let helpHubThemeDataLocalStr = localStorage.getItem(entityId);
    if (helpHubThemeDataLocalStr) {
      setStyleConfigApi((prev) => ({
        ...prev,
        ...JSON.parse(helpHubThemeDataLocalStr).styleConfig,
        ...styleConfig,
      }));
      setContentConfigApi((prev) => ({
        ...prev,
        ...JSON.parse(helpHubThemeDataLocalStr).contentConfig,
        ...contentConfig,
      }));
    }
    getOrCreateQuest();
  }, []);

  useEffect(() => {
    let arr = taskData
      ?.filter((ele: QuestCriteriaWithStatusType) => ele.completed === true)
      .map((ele: QuestCriteriaWithStatusType) => ele.criteriaId);
    // if (onlineComponent) {
    setClaimStatusTasks(arr);
    // }
  }, [taskData]);

  useEffect(() => {
    let arr = updateData
      .filter((ele: QuestCriteriaWithStatusType) => ele.completed === true)
      .map((ele: QuestCriteriaWithStatusType) => ele.criteriaId);
    // if (onlineComponent) {
    setClaimStatusUpdates(arr);
    // }
  }, [updateData]);

  useEffect(() => {
    setPrevSelectedSection(selectedSection);
  }, [selectedSection]);

  useEffect(() => {
    if (!isPopUp) {
      setHelpHub(true);
    }
    if (iconPosition == "left") {
      document.documentElement.style.setProperty("--main-direction-transform", "translateY(50%) translateX(-50%) scale(0)");
      document.documentElement.style.setProperty("--second-direction-transform", "translateY(50%) translateX(-50%) scale(0)");
    } else {
      document.documentElement.style.setProperty("--main-direction-transform", "translateY(50%) translateX(50%) scale(0)");
      document.documentElement.style.setProperty("--second-direction-transform", "translateY(0) translateX(100%) scale(1)");
    }
  }, [iconPosition]);

  const box_ref = useRef<HTMLDivElement>(null);
  const trigger_ref = useRef<HTMLDivElement>(null);
  const closeModal = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    let target = e.target as Element;
    if (
      box_ref.current?.contains(target) ||
      trigger_ref.current?.contains(target)
    ) {
    } else {
      setHelpHub(false);
      isActive && isActive(false);
    }
  };

  const Q = hexToRgb("#10131A");

  if (apiCallRunning) {
    return null;
  }

  function renderLogo() {
    if (!isFetchedEntityDetails) {
      return null;
    }
    if (!botLogo?.logo) {
      return (
        <img
          src={entityLogoApi || entityImage || quest_white}
          className={`helphub-open-messagesIcon ${!isOpen ? "show-icon" : ""}`}
          alt="Default Logo"
          style={botLogo?.style}
        />
      );
    }

    if (typeof botLogo.logo === "string") {
      return (
        <img
          src={botLogo.logo}
          className={`helphub-open-messagesIcon ${!isOpen ? "show-icon" : ""}`}
          alt="Custom Logo"
          style={botLogo.style}
        />
      );
    }

    return (
      <div
        className={`helphub-open-messagesIcon ${!isOpen ? "show-icon" : ""}`}
        style={botLogo.style}
      >
        {botLogo.logo}
      </div>
    );
  }

  return (
    <>
      {isPopUp && (
        // <div
        //   style={{
        //     fontFamily: themeConfig.fontFamily || "'Figtree', sans-serif",
        //     width: position == "SIDEBAR" && isOpen ? "100vw" : "",
        //     height: position == "SIDEBAR" && isOpen ? "100vh" : "",
        //     position: position == "SIDEBAR" && isOpen ? "fixed" : "static",
        //     top: "0",
        //     left: "0",
        //     zIndex: isOpen ? 9999 : ''
        //   }}
        // >
          // <div className={"custom-helphubIconUpperCont"} ref={trigger_ref} style={{ ...iconPositionValues, [iconPosition]: ((iconPositionValues?.[iconPosition] || 0) + 20) + "px" }}>
            <div
              id="helpHub"
              className={`${position == "SIDEBAR"
                ? "custom-helpHubMainCont-sidebar"
                : "customHelpHubMainCont"
                } ${isOpen ? "custom-animated" : ""}`}
              style={{
                height:
                  position === "SIDEBAR" ? "100vh" : styleConfig?.Main?.height,
                width: styleConfig?.Main?.width,
                borderRadius:
                  QuestThemeData?.borderRadius || BrandTheme?.borderRadius,
                boxShadow: styleConfig?.Main?.boxShadow,
                ...(position == "SIDEBAR"
                  ? { [iconPosition]: (iconPositionValues?.[iconPosition] || 0) + "px" }
                  : { [iconPosition]: '10px' }
                ),
              }}
              ref={box_ref}
            >

              {selectedSection === "Home" ? (
                <CustomHelpHubHome
                  questsData={chieldQuestCriteria}
                  setSelectedSection={setSelectedSection}
                  parentQuest={parentQuest}
                  userId={userId}
                  token={token}
                  styleConfig={styleConfigApi}
                  // contentConfig={contentConfig?.Home}
                  contentConfig={contentConfigApi?.Home}
                  claimStatusTasks={claimStatusTasks}
                  taskStatus={taskStatus}
                  onlineComponent={true}
                  showFeedback={showFeedback}
                  setShowFeedback={setShowFeedback}
                  entityImage={entityLogoApi || entityImage}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  contentData={contentData}
                  position={position}
                  setPositionInLocal={setPositionInLocal}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  onClose={onClose}
                  sectionConfig={sectionConfigState}
                />
              ) : (
                ""
              )}

              {selectedSection === "Chat" ? (
                <CustomHelpHubChat
                  // contentConfig={contentConfig?.Chat}
                  contentConfig={contentConfigApi?.Chat}
                  apiType={apiType}
                  entityId={entityId}
                  userId={userId}
                  token={token}
                  apiKey={apiKey}
                  styleConfig={styleConfigApi}
                  showBottomNavigation={showBottomNavigation}
                  setShowBottomNavigation={setShowBottomNavigation}
                  entityImage={entityLogoApi || entityImage}
                  entityName={entityName}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  position={position}
                  sendAutoMessage={sendAutoMessage}
                  setSendAutoMessage={setSendAutoMessage}
                  chat={chat}
                  setChat={setChat}
                  filterChat={filterChat}
                  setFilterChat={setFilterChat}
                  fetchData={fetchData}
                  setFetchData={setFetchData}
                  entityAuthenticationToken={entityAuthenticationToken}
                  defaultAutoPopupMessagesApi={defaultAutoPopupMessagesApi}
                  isPopMessageAudio={isPopMessageAudio}
                  setOpenCloseChatPopup={setOpenCloseChatPopup}
                  openCloseChatPopup={openCloseChatPopup}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Help" ? (
                <CustomHelpHubHelp
                  faqData={
                    !!chieldQuestCriteria?.length ? chieldQuestCriteria[1] : []
                  }
                  styleConfig={styleConfigApi}
                  contentConfig={contentConfigApi?.Help}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Updates" ? (
                <CustomHelpHubUpdates
                  updateData={!!chieldQuestCriteria?.length ? updateData : []}
                  contentConfig={contentConfigApi?.Updates}
                  styleConfig={styleConfigApi}
                  questId={
                    parentQuest?.childCampaignActions[2].campaignId || ""
                  }
                  campaignVariationId={
                    parentQuest?.childCampaignActions[2].campaignVariationId ||
                    ""
                  }
                  userId={userId}
                  token={token}
                  claimStatusUpdates={claimStatusUpdates}
                  setClaimStatusUpdates={setClaimStatusUpdates}
                  onlineComponent={true}
                  showBottomNavigation={showBottomNavigation}
                  setShowBottomNavigation={setShowBottomNavigation}
                  entityImage={entityImage}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Tasks" ? (
                <CustomHelpHubTasks
                  tasksData={!!chieldQuestCriteria?.length ? taskData : []}
                  contentConfig={contentConfigApi?.Tasks}
                  styleConfig={styleConfigApi}
                  questId={
                    parentQuest?.childCampaignActions[3]?.campaignId || ""
                  }
                  campaignVariationId={
                    parentQuest?.childCampaignActions[3]?.campaignVariationId ||
                    ""
                  }
                  token={token}
                  userId={userId}
                  claimStatusTasks={claimStatusTasks}
                  setClaimStatusTasks={setClaimStatusTasks}
                  onlineComponent={true}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  contentData={contentData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}

              <div className="helphubBottomCont">
                <div
                  className={`custom-helphubSvgCont ${showBottomNavigation ? "customShowNav" : "customhideNav"
                    }`}
                >
                  <div>
                    {sectionConfigState?.Home && <div onClick={() => setSelectedSection("Home")}>
                      <HelphubSvg
                        type={"home"}
                        primaryColor={
                          selectedSection == "Home"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Home" ? "white" : "#B9B9B9"
                        }
                      />
                      <div
                        style={{
                          color:
                            selectedSection == "Home"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Home" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Home
                      </div>
                    </div>}

                    {sectionConfigState?.Chat && <div onClick={() => setSelectedSection("Chat")}>
                      {/* Chat icon  */}
                      <HelphubSvg
                        type={"Chat"}
                        primaryColor={
                          selectedSection == "Chat"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Chat" ? "white" : "#B9B9B9"
                        }
                      />
                      {/* chat text  */}
                      <div
                        style={{
                          color:
                            selectedSection == "Chat"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Chat" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Chat
                      </div>
                    </div>}

                    {sectionConfigState?.FAQs && <div onClick={() => setSelectedSection("Help")}>
                      {/* help icon  */}
                      <HelphubSvg
                        type={"Help"}
                        primaryColor={
                          selectedSection == "Help"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Help" ? "white" : "#B9B9B9"
                        }
                      />
                      {/* chat text  */}
                      <div
                        style={{
                          color:
                            selectedSection == "Help"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Help" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        FAQs
                      </div>
                    </div>}

                    {sectionConfigState?.Updates && <div onClick={() => setSelectedSection("Updates")}>
                      <HelphubSvg
                        type={"Updates"}
                        primaryColor={
                          selectedSection == "Updates"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Updates" ? "white" : "#B9B9B9"
                        }
                      />

                      <div
                        style={{
                          color:
                            selectedSection == "Updates"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight:
                            selectedSection == "Updates" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Updates
                      </div>
                    </div>}

                    {sectionConfigState?.Tasks && <div onClick={() => setSelectedSection("Tasks")}>
                      {/* task icon  */}
                      <HelphubSvg
                        type={"Tasks"}
                        primaryColor={
                          selectedSection == "Tasks"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Tasks" ? "white" : "#B9B9B9"
                        }
                      />
                      {/* ttask text  */}
                      <div
                        style={{
                          color:
                            selectedSection == "Tasks"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight:
                            selectedSection == "Tasks" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Tasks
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
            </div>
          // </div>
        // </div>
      )}

      {!isPopUp && (
        <div
          style={{
            fontFamily: themeConfig.fontFamily || "'Figtree', sans-serif",
            // width: position == "SIDEBAR" && helpHub ? "100vw" : "",
            width: "100%",
            height: "100%",
            // height: position == "SIDEBAR" && helpHub ? "100vh" : "",
            // position: position == "SIDEBAR" && helpHub ? "fixed" : "static",
            // top: "0",
            // left: "0",
          }}
          onClick={(e) => closeModal(e)}
        >
          <div
            className={"helphubIconUpperCont"}
            ref={trigger_ref}
            style={{
              height: "100%",
              ...iconPositionValues
            }}
          >
            {/* help button  */}
            {/* <div
              className={"custom-helhubIconCont"}
              onClick={() => {
                setHelpHub((prev) => !prev);
                isActive && isActive(!helpHub);
              }}
              style={{
                background:
                  styleConfig?.QuestLogo?.QuestLogoBackground ||
                  QuestThemeData?.accentColor,
                boxShadow: `-1px -1px 50.3px -1px rgba(${Q}, 0.75)`,
              }}
            >
              <img
                src={addIcon}
                className={`helphub-open-addIcon ${helpHub ? "show-icon" : ""}`}
              />

              {renderLogo()}
            </div> */}
            {/* {
              helphubPosition == "USER_CHOICE" && (
                // <div className="helphub-open-resizeIcon" onClick={() => setPositionInLocal(position == "POPUP" ? "SIDEBAR" : "POPUP")}>
                <img
                  src={position == "POPUP" ? resize2 : resize}
                  alt=""
                  className="helphub-open-resizeIcon"
                  style={{
                    background:
                      styleConfig?.QuestLogo?.QuestLogoBackground ||
                      QuestThemeData?.accentColor,
                  }}
                  onClick={() =>
                    setPositionInLocal(position == "POPUP" ? "SIDEBAR" : "POPUP")
                  }
                />
              )
              // </div>
            } */}

            {/* {!!defaultAutoPopupMessagesApi.length ? (
              <div
                className={`helpHubMainCont-default-popup ${autoPopupMessage
                  ? "helpHubMainCont-default-popup-animated"
                  : ""
                  }`}
              >
                <div
                  className="home-back-btn"
                  onClick={() => setAutoPopupMessage(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M5.63184 14.3697L10.001 10.0005L14.3702 14.3697M14.3702 5.63135L10.0002 10.0005L5.63184 5.63135"
                      stroke="#696969"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="home-assistant-msg">
                  <img
                    style={{
                      background:
                        styleConfig?.QuestLogo?.QuestLogoBackground ||
                        QuestThemeData.accentColor,
                    }}
                    src={entityLogoApi || entityImage}
                    alt=""
                  />
                  <p>Hello there👋, How can I help you?</p>
                </div>
                <div className="home-user-msg">
                  {defaultAutoPopupMessagesApi.map((ele, index) => {
                    return (
                      <p
                        style={{
                          background:
                            styleConfig?.QuestLogo?.QuestContent?.background ||
                            QuestThemeData.accentColor,
                          color:
                            styleConfig?.QuestLogo?.QuestContent?.color ||
                            BrandTheme?.contentColor,
                          ...styleConfig?.QuestLogo?.QuestContent,
                        }}
                        key={index}
                        onClick={() => setSendAutoMessage(ele)}
                      >
                        {ele}
                      </p>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            )} */}

            <div
              id="helpHub"
              className={`${position == "SIDEBAR"
                ? "custom-helpHubMainCont-sidebar"
                : "customHelpHubMainCont"
                } ${isOpen ? "custom-animated" : ""}`}
              style={{
                height: "100%",
                width: styleConfig?.Main?.width,
                borderRadius:
                  QuestThemeData?.borderRadius || BrandTheme?.borderRadius,
                boxShadow: styleConfig?.Main?.boxShadow,
                ...(position == "SIDEBAR"
                  ? { [iconPosition]: (iconPositionValues?.[iconPosition] || 0) + "px" }
                  : { [iconPosition]: '10px' }
                )
              }}
              ref={box_ref}
            >
              {selectedSection === "Home" ? (
                <CustomHelpHubHome
                  questsData={chieldQuestCriteria}
                  setSelectedSection={setSelectedSection}
                  parentQuest={parentQuest}
                  userId={userId}
                  token={token}
                  styleConfig={styleConfigApi}
                  // contentConfig={contentConfig?.Home}
                  contentConfig={contentConfigApi?.Home}
                  claimStatusTasks={claimStatusTasks}
                  taskStatus={taskStatus}
                  onlineComponent={true}
                  showFeedback={showFeedback}
                  setShowFeedback={setShowFeedback}
                  entityImage={entityLogoApi || entityImage}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  contentData={contentData}
                  position={position}
                  setPositionInLocal={setPositionInLocal}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  onClose={onClose}
                  sectionConfig={sectionConfigState}
                />
              ) : (
                ""
              )}

              {selectedSection === "Chat" ? (
                <CustomHelpHubChat
                  contentConfig={contentConfigApi?.Chat}
                  apiType={apiType}
                  entityId={entityId}
                  userId={userId}
                  token={token}
                  apiKey={apiKey}
                  styleConfig={styleConfigApi}
                  showBottomNavigation={showBottomNavigation}
                  setShowBottomNavigation={setShowBottomNavigation}
                  entityImage={entityImage}
                  entityName={entityName}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  position={position}
                  sendAutoMessage={sendAutoMessage}
                  setSendAutoMessage={setSendAutoMessage}
                  chat={chat}
                  setChat={setChat}
                  filterChat={filterChat}
                  setFilterChat={setFilterChat}
                  fetchData={fetchData}
                  setFetchData={setFetchData}
                  entityAuthenticationToken={entityAuthenticationToken}
                  defaultAutoPopupMessagesApi={defaultAutoPopupMessagesApi}
                  isPopMessageAudio={isPopMessageAudio}
                  setOpenCloseChatPopup={setOpenCloseChatPopup}
                  openCloseChatPopup={openCloseChatPopup}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Help" ? (
                <CustomHelpHubHelp
                  faqData={
                    !!chieldQuestCriteria?.length ? chieldQuestCriteria[1] : []
                  }
                  styleConfig={styleConfigApi}
                  contentConfig={contentConfigApi?.Help}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Updates" ? (
                <CustomHelpHubUpdates
                  updateData={!!chieldQuestCriteria?.length ? updateData : []}
                  contentConfig={contentConfigApi?.Updates}
                  styleConfig={styleConfigApi}
                  questId={
                    parentQuest?.childCampaignActions[2].campaignId || ""
                  }
                  campaignVariationId={
                    parentQuest?.childCampaignActions[2].campaignVariationId ||
                    ""
                  }
                  userId={userId}
                  token={token}
                  claimStatusUpdates={claimStatusUpdates}
                  setClaimStatusUpdates={setClaimStatusUpdates}
                  onlineComponent={true}
                  showBottomNavigation={showBottomNavigation}
                  setShowBottomNavigation={setShowBottomNavigation}
                  entityImage={entityImage}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}
              {selectedSection === "Tasks" ? (
                <CustomHelpHubTasks
                  tasksData={!!chieldQuestCriteria?.length ? taskData : []}
                  contentConfig={contentConfigApi?.Tasks}
                  styleConfig={styleConfigApi}
                  questId={
                    parentQuest?.childCampaignActions[3]?.campaignId || ""
                  }
                  campaignVariationId={
                    parentQuest?.childCampaignActions[3]?.campaignVariationId ||
                    ""
                  }
                  token={token}
                  userId={userId}
                  claimStatusTasks={claimStatusTasks}
                  setClaimStatusTasks={setClaimStatusTasks}
                  onlineComponent={true}
                  setHelpHub={setHelpHub}
                  isActive={isActive}
                  uniqueUserId={uniqueUserId}
                  uniqueEmailId={uniqueEmailId}
                  entityAuthenticationToken={entityAuthenticationToken}
                  BrandTheme={BrandTheme}
                  QuestThemeData={QuestThemeData}
                  contentData={contentData}
                  setPositionInLocal={setPositionInLocal}
                  onClose={onClose}
                />
              ) : (
                ""
              )}

              <div className="helphubBottomCont">
                <div
                  className={`custom-helphubSvgCont ${showBottomNavigation ? "customShowNav" : "customhideNav"
                    }`}
                >
                  <div>
                    <div onClick={() => setSelectedSection("Home")}>
                      <HelphubSvg
                        type={"home"}
                        primaryColor={
                          selectedSection == "Home"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Home" ? "white" : "#B9B9B9"
                        }
                      />
                      <div
                        style={{
                          color:
                            selectedSection == "Home"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Home" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Home
                      </div>
                    </div>

                    <div onClick={() => setSelectedSection("Chat")}>
                      <HelphubSvg
                        type={"Chat"}
                        primaryColor={
                          selectedSection == "Chat"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Chat" ? "white" : "#B9B9B9"
                        }
                      />
                      <div
                        style={{
                          color:
                            selectedSection == "Chat"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Chat" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Chat
                      </div>
                    </div>

                    <div onClick={() => setSelectedSection("Help")}>
                      <HelphubSvg
                        type={"Help"}
                        primaryColor={
                          selectedSection == "Help"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Help" ? "white" : "#B9B9B9"
                        }
                      />
                      <div
                        style={{
                          color:
                            selectedSection == "Help"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight: selectedSection == "Help" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        FAQs
                      </div>
                    </div>

                    <div onClick={() => setSelectedSection("Updates")}>
                      <HelphubSvg
                        type={"Updates"}
                        primaryColor={
                          selectedSection == "Updates"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Updates" ? "white" : "#B9B9B9"
                        }
                      />

                      <div
                        style={{
                          color:
                            selectedSection == "Updates"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight:
                            selectedSection == "Updates" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Updates
                      </div>
                    </div>

                    <div onClick={() => setSelectedSection("Tasks")}>
                      <HelphubSvg
                        type={"Tasks"}
                        primaryColor={
                          selectedSection == "Tasks"
                            ? "#00CA8D" : "#9CA3AF"
                        }
                        secondaryColor={
                          selectedSection == "Tasks" ? "white" : "#B9B9B9"
                        }
                      />
                      <div
                        style={{
                          color:
                            selectedSection == "Tasks"
                              ? "#00CA8D" : "#9CA3AF",
                          fontWeight:
                            selectedSection == "Tasks" ? "600" : "400",
                        }}
                        className="customHelphubSvgTitle"
                      >
                        Tasks
                      </div>
                    </div>
                  </div>
                </div>

                {showFooterApi && (
                  <div
                    className="helphubFooterCont"
                    onClick={() => {
                      window.open(
                        footerLink ? footerLink : "https://www.plgos.com/"
                      );
                    }}
                  >
                    <div className="helphubFooterText">
                      {footerText || "Powered by PLG OS"}
                    </div>
                    <div>
                      <HelphubSvg type="footerLogo" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomHelpHub;
